module.exports = __webpack_public_path__ + "img/slide2-4.68c38bb9.png";